// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const SelectIndicatorIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="SelectIndicatorIcon" ref={forwardedRef} {...props}>
      <path d="M13 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const SelectIndicatorIcon = /* @__PURE__ */ Object.assign(
  SelectIndicatorIconComponent,
  { displayName: 'SelectIndicatorIcon' },
);
